import appApi from "@/services/api";

const useClientes = () => {
  const getClientes = async () => {
    try {
      const response = await appApi().get(`clientes?all=true`);

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    getClientes,
  };
};

export default useClientes;
